const state = {
    filterCache: [],
    detailed: "",
    planUnpaidList: "",
    requestRoute: "", //页面路径
  }
  const mutations = {
    //添加修改表头状态
    requestRoute(state, data) {
        // console.log(data);
        let text = encodeURIComponent(data)
        state.requestRoute = text
        // console.log(state.requestRoute);
        
    },
    //添加修改表头状态
    setHeaderFilter(state, data) {
        // state.filterCache = []
        if(state.filterCache.length == 0) {
            state.filterCache.push(data)
        }else {
            for(let i=0; i<state.filterCache.length;i++) {
                if(state.filterCache[i].column == data.column) {
                    state.filterCache[i] = data
                    return
                }
            }
            state.filterCache.push(data)
        }
        // console.log(state.filterCache);
    },
    //删除表头所有状态
    delHeaderFilter(state, tableName) {
        console.log('sahnchu ')
       let filterList = JSON.parse(JSON.stringify(state.filterCache))
       for(let i=0;i<filterList.length;i++) {
            if(filterList[i].table === tableName && filterList.length==1) {
                filterList = []
            }else if(filterList[i].table === tableName) {
                console.log(filterList);
                filterList.splice(i--, 1)　
            }
       }
       // console.log(filterList);
       state.filterCache = filterList
    //    state.filterCache = filterList.filter(item=>select.includes(data)).map(item=>item)
    },
    //重置时 删除单个列表头状态
    restHeaderFilter(state, data) {
        console.log('state',state)
        console.log('data',data)
        let filterList = JSON.parse(JSON.stringify(state.filterCache))
        for(let i=0;i<filterList.length;i++) {
             if(filterList[i].table === data.tableName && filterList[i].column === data.columnName && filterList.length==1) {
                 filterList = []
             }else if(filterList[i].table === data.tableName && filterList[i].column === data.columnName) {
                 filterList.splice(i, 1)
             }
        }
        // console.log(filterList);
       state.filterCache = filterList
    },

    //跳转传参报表缓存加载判断参数修改
    detailed(state, data) {
        state.detailed = data
    },
    planUnpaidList(state, data) {
        state.planUnpaidList = data
    },
    
  }
  
  export default {
    namespaced: true,
    state,
    mutations
  }
  